import React from "react";
import "./App.css";
import TasksList from "./components/TasksList/TasksList";
import plate from "./plate.png";

import { BiVolume } from "react-icons/bi";
import { BiVolumeFull } from "react-icons/bi";

function App() {
  const [sound, setSound] = React.useState(true);
  const iconStyle = { color: "D9D9D9", fontSize: "2em" };

  function handleSound() {
    setSound(!sound);
    localStorage.setItem("soundSettings", JSON.stringify(!sound));
  }

  // Only try to load saved sound settings if they exist.
  React.useEffect(() => {
    if (JSON.parse(localStorage.getItem("soundSettings")) !== null) {
      setSound(JSON.parse(localStorage.getItem("soundSettings")));
    }
  }, []);

  return (
    <div className="App">
      <div className="container mx-auto max-w-2xl flex-col space-y-12 bg-white p-9 dark:bg-zinc-800 dark:text-white sm:mt-0 md:mt-20 md:rounded-2xl md:shadow-lg">
        <header className="flex justify-between">
          <img src={plate} alt="3D illustration of a plate" className="h-32" />
          <button
            onClick={() => {
              handleSound();
            }}
          >
            {sound ? (
              <BiVolumeFull style={iconStyle} className="dark:opacity-30" />
            ) : (
              <BiVolume style={iconStyle} className="dark:opacity-30" />
            )}
          </button>
        </header>
        <TasksList sound={sound} />
      </div>
      <div className="mx-auto mt-5 mb-20 max-w-2xl px-8 text-center">
        <p className="text-xs text-slate-400 dark:text-zinc-600/80">
          Please don't use this and expect your data to survive. This is just a
          stupid experiment that might be gone tomorrow.
        </p>
      </div>
    </div>
  );
}

export default App;
